import CustomButton from '@/common/CustomButton';
import {
  CalendarOutlined,
  CheckOutlined,
  DeleteOutlined,
  EditOutlined
} from '@ant-design/icons';
import { useState } from 'react';
import MarkAsCompleteModal from './MarkAsCompleteModal';
import RescheduleModal from './RescheduleModal';
import {
  FOLLOW_UP_STATUS_TYPES,
  getFormattedDateToDisplay
} from 'utilities/helpers';
import { Popconfirm, Skeleton } from 'antd';
import CreateFollowUpModal from './CreateFollowUpModal';
import { useDispatch } from 'react-redux';
import { createFollowUp } from '../redux/slice';

export default function DetailCard({ borderColor, data, onAssign }) {
  const [isMarkAsCompleteModalOpen, setIsMarkAsCompleteModalOpen] =
    useState(null);
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(null);
  const [isUpdateFollowUpModalOpen, setIsUpdateFollowUpModalOpen] =
    useState(null);
  const dispatch = useDispatch();
  const isCompleted = data.status === FOLLOW_UP_STATUS_TYPES.completed;

  if (!data) {
    return <Skeleton active paragraph={{ rows: 2 }} />;
  }

  const handleFollowUpDelete = (id) => {
    const payload = {
      type: 'delete',
      id
    };

    dispatch(createFollowUp(payload)).then((res) => {
      if (res?.payload?.success) {
        onAssign();
      }
    });
  };

  return (
    <>
      <div
        style={{
          borderLeft: '4px solid',
          borderColor: isCompleted ? '#52c41a' : borderColor,
          backgroundColor: isCompleted ? '#e6fff0' : '#fff'
        }}
        className="flex flex-col gap-0 px-3 py-2 rounded-lg shadow-bottom md:p-4"
      >
        <div className="flex justify-between gap-5 leading-none">
          <label className="!text-sm !text-[#1f2937] font-bold leading-none">
            {data.title}
          </label>
          {/* action buttons */}
          {isCompleted ? null : (
            <div className="items-center hidden gap-4 sm:flex">
              {/* <CustomButton
              className={
                '!bg-transparent hover:!scale-105 transition-all hover:!bg-[#0653fa] hover:!border-none hover:!text-white !text-[#0653fa] duration-300 ease-linear !text-xs rounded-md'
              }
              style={{ border: '1px solid #0653fa' }}
              htmlType="submit"
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => setIsUpdateFollowUpModalOpen(data.id)}
            >
              Edit
            </CustomButton> */}
              <CustomButton
                className={
                  '!bg-transparent hover:!scale-105 transition-all hover:!bg-[#64748b] hover:!border-none hover:!text-white !text-[#64748b] duration-300 ease-linear !text-xs rounded-md'
                }
                style={{ border: '1px solid #64748b' }}
                htmlType="submit"
                type="primary"
                size="small"
                icon={<CalendarOutlined />}
                onClick={() => setIsRescheduleModalOpen(data.id)}
              >
                Reschedule
              </CustomButton>

              <CustomButton
                className={
                  '!bg-transparent  hover:!scale-105 transition-all hover:!bg-[#52c41a] hover:!border-none hover:!text-white !text-[#52c41a] duration-300 ease-linear !text-xs rounded-md'
                }
                style={{ border: '1px solid #52c41a' }}
                htmlType="submit"
                type="primary"
                size="small"
                icon={<CheckOutlined />}
                onClick={() => setIsMarkAsCompleteModalOpen(data.id)}
              >
                Done
              </CustomButton>

              {/* <Popconfirm
              title={
                <>
                  <div>Please Confirm</div>
                  <div
                    style={{
                      color: 'rgba(0, 0, 0, 0.45)'
                    }}
                  >
                    Are you sure you want to delete this follow-up?
                  </div>
                </>
              }
              onConfirm={() => handleFollowUpDelete(data.id)}
              okText="Delete"
              cancelText="No"
              placement="left"
            >
              <CustomButton
                className={
                  '!bg-transparent  hover:!scale-105 transition-all hover:!bg-[#ef4444] hover:!border-none hover:!text-white !text-[#ef4444] duration-300 ease-linear !text-xs rounded-md'
                }
                style={{ border: '1px solid #ef4444' }}
                htmlType="submit"
                type="primary"
                size="small"
                icon={<DeleteOutlined />}
              >
                Delete
              </CustomButton>
            </Popconfirm> */}
            </div>
          )}
        </div>

        <span
          type="secondary"
          className={`leading-none !text-xs !text-[#64748b] w-full md:w-[80%] mb-1.5 ${
            isCompleted ? 'mt-1' : ''
          }`}
        >
          {data.followup_notes}
        </span>

        <span
          type="secondary"
          className={'leading-none !text-xs !text-[#00000072]'}
        >
          {data.assignee.first_name} {data.assignee.last_name}{' '}
          <span className="inline-block w-6 text-center">→</span>{' '}
          {data.with_whom} &middot;{' '}
          <span>
            <span className="font-semibold">Due:</span>{' '}
            {getFormattedDateToDisplay(data.followup_date)}
          </span>
        </span>

        {/*mobile action buttons */}
        {isCompleted ? null : (
          <div className="flex items-center justify-end gap-4 mt-3 sm:hidden">
            <CustomButton
              className={
                '!bg-transparent hover:!scale-105 transition-all hover:!bg-[#64748b] hover:!border-none hover:!text-white !text-[#64748b] duration-300 ease-linear !text-xs rounded-md'
              }
              style={{ border: '1px solid #64748b' }}
              htmlType="submit"
              type="primary"
              size="small"
              icon={<CalendarOutlined />}
              onClick={() => setIsRescheduleModalOpen(data.id)}
            >
              Reschedule
            </CustomButton>
            <CustomButton
              className={
                '!bg-transparent  hover:!scale-105 transition-all hover:!bg-[#52c41a] hover:!border-none hover:!text-white !text-[#52c41a] duration-300 ease-linear !text-xs rounded-md'
              }
              style={{ border: '1px solid #52c41a' }}
              htmlType="submit"
              type="primary"
              size="small"
              icon={<CheckOutlined />}
              onClick={() => setIsMarkAsCompleteModalOpen(data.id)}
            >
              Done
            </CustomButton>
          </div>
        )}
      </div>

      {/* update follow up modal */}
      <CreateFollowUpModal
        setIsOpen={setIsUpdateFollowUpModalOpen}
        isOpen={isUpdateFollowUpModalOpen}
        onAssign={onAssign}
        data={data}
      />

      {/*mark as complete modal */}
      <MarkAsCompleteModal
        setIsOpen={setIsMarkAsCompleteModalOpen}
        isOpen={isMarkAsCompleteModalOpen}
        onAssign={onAssign}
        data={data}
      />

      {/*reschedule modal */}
      <RescheduleModal
        setIsOpen={setIsRescheduleModalOpen}
        isOpen={isRescheduleModalOpen}
        onAssign={onAssign}
        data={data}
      />
    </>
  );
}
